// Preset parcel draft helpers
import { getInput } from '../../core/dom.js';
import type { PresetParcel } from '../../types/api.js';

export function emptyPresetParcel(): Required<PresetParcel> {
  return { weightKg: '', lengthCm: '', widthCm: '', heightCm: '' };
}

export function normalizeParcelDraft(p: PresetParcel | null | undefined): Required<PresetParcel> {
  if (!p || typeof p !== 'object') return emptyPresetParcel();
  return {
    weightKg: String(p.weightKg || '').trim(),
    lengthCm: String(p.lengthCm || '').trim(),
    widthCm: String(p.widthCm || '').trim(),
    heightCm: String(p.heightCm || '').trim()
  };
}

export function fillCreateWizardParcelInputs(parcel: PresetParcel | null | undefined): void {
  const n = normalizeParcelDraft(parcel);
  const wEl = getInput('create-step-parcel-weight');
  const le = getInput('create-step-parcel-len');
  const wi = getInput('create-step-parcel-wid');
  const hg = getInput('create-step-parcel-hgt');
  if (wEl) wEl.value = n.weightKg;
  if (le) le.value = n.lengthCm;
  if (wi) wi.value = n.widthCm;
  if (hg) hg.value = n.heightCm;
}

export function readCreateWizardParcelInputs(): Required<PresetParcel> {
  const wEl = getInput('create-step-parcel-weight');
  const le = getInput('create-step-parcel-len');
  const wi = getInput('create-step-parcel-wid');
  const hg = getInput('create-step-parcel-hgt');
  return {
    weightKg: (wEl?.value || '').trim(),
    lengthCm: (le?.value || '').trim(),
    widthCm: (wi?.value || '').trim(),
    heightCm: (hg?.value || '').trim()
  };
}

export function formatParcelReview(parcel: PresetParcel | null | undefined): string {
  const n = normalizeParcelDraft(parcel);
  const hasAny = !!(n.weightKg || n.lengthCm || n.widthCm || n.heightCm);
  if (!hasAny) return '—';
  const parts: string[] = [];
  if (n.weightKg) parts.push(n.weightKg + ' кг');
  const dim = [n.lengthCm, n.widthCm, n.heightCm].filter(Boolean).join('×');
  if (dim) parts.push(dim + ' см');
  return parts.join(', ') || '—';
}
